import { useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'
import { useCmsConfigStore } from '@/stores/cms/cmsConfigStore'

/**
 * Boots game links from CMS `/pos/bootstrap` `games.docs`
 */
const bootGames = () => {
  const { cmsConfig } = useCmsConfigStore()
  const { setGameLinks } = useGamesStore()

  setGameLinks(cmsConfig?.games?.docs ?? [])
}

export { bootGames }
